import React, { useEffect } from 'react';
import { AppRouter } from './routes/Router';
import { DevelopmentModeToggleProvider } from './context/DevelopmentModeProvider';
import { SnackbarProvider } from 'notistack';
import { useDateLocale } from './hooks/useDateLocale';
import { resolveAppLanguage } from '@helpers/dateHelpers';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useConfigureEcho } from '@hooks/useConfigureEcho';
import './quill/quill';
import { TenantProvider } from '@context/TenantProvider';
import { IBeforeInstallPromptEvent } from './global';
import { HelmetProvider } from 'react-helmet-async';

const App = (): JSX.Element => {
  useDateLocale();
  useConfigureEcho();

  // TODO: Refactor to own file. Had some issues with that the event was not registered.
  // Only on this place it gets registered and triggered..
  useEffect(() => {
    const handler = (e: Event) => {
      const event = e as IBeforeInstallPromptEvent;

      event.preventDefault();

      window.deferredPrompt = event;
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  return (
    <TenantProvider>
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        adapterLocale={resolveAppLanguage()}
      >
        <HelmetProvider>
          <SnackbarProvider>
            <DevelopmentModeToggleProvider>
              <AppRouter />
            </DevelopmentModeToggleProvider>
          </SnackbarProvider>
        </HelmetProvider>
      </LocalizationProvider>
    </TenantProvider>
  );
};

export default App;
